import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { CurrentBg, CurrentMobile } from '../../assets/img';
import { BusinessForm } from '../../components';
// import { Footer } from '../../components/footer';
import { Screen } from '../../styles';

// const Navigation = NavigationBar.Navigation;
const StepOne = BusinessForm.StepOne;
const StepTwo = BusinessForm.StepTwo;
const StepThree = BusinessForm.StepThree;
const StepFour = BusinessForm.StepFour;
const StepFive = BusinessForm.StepFive;
const Business = () => {
  //Scroll to top on page load
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [step, setStep] = useState(0);
  const [user, setUser] = useState({
    account: '',
    bvn: '',
    dob: '',
    mobile: '',
    businessName: '',
    startDate: '',
    regNumber: '',
    tinNumber: '',
    address1: '',
    address2: '',
    country: '',
    state: '',
    zip: '',
    officeNumber: '',
    email: '',
    surname: '',
    firstname: '',
    middlename: '',
    gender: '',
    marital: '',
    ownerAddress1: '',
    ownerAddress2: '',
    ownerCountry: '',
    ownerState: '',
    ownerZip: '',
    ownerMailingAddress1: '',
    ownerMailingAddress2: '',
    ownerMailingCountry: '',
    ownerMailingState: '',
    ownerMailingZip: '',
    homeNumber: '',
    education: '',
    school: '',
    ways: [],
  });

  const {
    account,
    bvn,
    dob,
    mobile,
    businessName,
    startDate,
    regNumber,
    tinNumber,
    address1,
    address2,
    country,
    state,
    zip,
    officeNumber,
    email,
    surname,
    firstname,
    middlename,
    gender,
    marital,
    ownerAddress1,
    ownerAddress2,
    ownerCountry,
    ownerState,
    ownerZip,
    ownerMailingAddress1,
    ownerMailingAddress2,
    ownerMailingCountry,
    ownerMailingState,
    ownerMailingZip,
    homeNumber,
    education,
    school,
    ways,
  } = user;
  const values = {
    account,
    bvn,
    dob,
    mobile,
    businessName,
    startDate,
    regNumber,
    tinNumber,
    address1,
    address2,
    country,
    state,
    zip,
    officeNumber,
    email,
    surname,
    firstname,
    middlename,
    gender,
    marital,
    ownerAddress1,
    ownerAddress2,
    ownerCountry,
    ownerState,
    ownerZip,
    ownerMailingAddress1,
    ownerMailingAddress2,
    ownerMailingCountry,
    ownerMailingState,
    ownerMailingZip,
    homeNumber,
    education,
    school,
    ways,
  };
  const nextStep = (e) => {
    e.preventDefault();
    setStep((prevState) => prevState + 1);
  };
  const prevStep = (e) => {
    e.preventDefault();
    setStep((prevState) => prevState - 1);
  };
  const handleChange = (input) => (e) => {
    setUser({
      ...user,
      [input]: e.target.value,
    });
  };

  const renderStepForm = () => {
    switch (step) {
      case 0:
        return (
          <StepOne
            next={nextStep}
            values={values}
            handleChange={handleChange}
          />
        );
      case 1:
        return (
          <StepTwo
            next={nextStep}
            prev={prevStep}
            values={values}
            handleChange={handleChange}
          />
        );
      case 2:
        return (
          <StepThree
            next={nextStep}
            prev={prevStep}
            values={values}
            handleChange={handleChange}
          />
        );
      case 3:
        return (
          <StepFour
            next={nextStep}
            prev={prevStep}
            values={values}
            handleChange={handleChange}
          />
        );
      case 4:
        return (
          <StepFive
            next={nextStep}
            prev={prevStep}
            handleChange={handleChange}
            values={values}
          />
        );
      default:
        return null;
    }
  };
  return (
    <Box>
      {/* nav */}
      {/* <Navigation /> */}
      {/* End of nav */}

      <Section className='hero'></Section>
      {/* Form */}
      <Section>
        <Container>
          {/* <Header>
            Open an Abbey <span>Business</span> Account
          </Header> */}
          <Paragraph>
          To open an account, Contact us at <br /> 
          <a href='mailto:customerexperience@abbeybank.com'>customerexperience@abbeybank.com</a>
          </Paragraph>
          {/* <Text>Coming Soon...</Text> */}
          {/* {renderStepForm()} */}
        </Container>
      </Section>
      {/* End of Form */}

      {/* Footer */}
      {/* <Footer /> */}
      {/* End of Footer */}
    </Box>
  );
};

const Box = styled.div`
  width: 100%;
  min-height: 100vh;
`;
const Section = styled.div`
  width: 100%;
  /* min-height: 100vh;
   */
  &.hero {
    min-height: 70vh;
  background: url(${CurrentBg});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
    ${Screen.mediumpc`
    min-height: 30vh!important;
    `}
    ${Screen.smallpc`
    min-height: 30vh!important;
    margin-top: 5rem!important;
    `}
      ${Screen.tablet`
    min-height: 30vh!important;
    `}
    ${Screen.mediumPhone`
    min-height: 30vh!important;
    margin-top: 5rem!important;
    `}
    ${Screen.phone`
    min-height: 30vh!important;
    margin-top: 5rem!important;
    `}
    ${Screen.smallPhone`
    min-height: 30vh!important;
    margin-top: 5rem!important;
    `}
  }
`;
const Container = styled.div`
  width: 80%;
  margin: 5rem auto 0;
  ${Screen.miniLargeScreen`
  width: 90%;
  margin: 3rem auto;
  word-break: break-all
  `}
  ${Screen.pad`
  width: 80%;
  margin: 5rem auto;
  word-break: break-all
  `}
  ${Screen.mediumpc`
  width: 80%;
  margin: 5rem auto;
  word-break: break-all
  `}
  ${Screen.smallpc`
  width: 70%;
  margin: 5rem auto!important;
  word-break: break-all
  `}
  ${Screen.tablet`
  width: 70%;
  margin: 5rem auto!important;
  word-break: break-all
  `}
  ${Screen.surfaceDuo`
  width: 80%;
  margin: 3rem auto!important;
  word-break: break-all
  `}
  ${Screen.mediumPhone`
  width: 90%;
  margin: 3rem auto!important;
  word-break: break-all
  `}
  ${Screen.phone`
  width: 90%;
  margin: 3rem auto!important;
  word-break: break-all
  `}
  ${Screen.smallPhone`
  width: 90%;
  margin: 3rem auto!important;
  word-break: break-all
  `}
  ${Screen.galaxyFold`
  width: 95%;
  margin: 3rem auto!important;
  word-break: break-all
  `}
`;
const Header = styled.h2`
  font-size: 2rem;
  color: #002668;
  text-align: center;

  span {
    color: #c81e19;
  }
`;
const Paragraph = styled.p`
 color: #9a9494;
  text-transform: uppercase;
  text-align: center;
  padding-bottom: 3rem;
  font-size: 1.1rem;
  margin-top: 3rem;

  a {
    color: #0867BE;
    padding-top: 1rem
  }

  ${Screen.smallpc`
  margin-top: 5rem!important;
  `}
  ${Screen.tablet`
  font-size: 1.1rem;
  `}
  ${Screen.mediumPhone`
  font-size: .9rem;
  `}
  ${Screen.phone`
  font-size: .9rem;
  `}
  ${Screen.smallPhone`
  font-size: .8rem;
  `}
  ${Screen.galaxyFold`
  font-size: .7rem;
  `}
`;
const Text = styled.h1`
text-align: center;
padding-top: 10rem;
`
export default Business;
